module.exports = __webpack_public_path__ + "static/img/SketchPng4f6da277ee626f2cd7f35cc7054a404f1d8eb194640fefdc5bf2f6b066de4042.37bf4457.png";